import { AppBar, styled } from "@mui/material";
import Copyright from "04UserPages/99Parts/Copyright";

const MyAppBar = styled(AppBar)(({ theme }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  top: "auto",
  bottom: 0,
}));

const Footer = () => {
  return (
    <MyAppBar position="fixed">
      <Copyright />
    </MyAppBar>
  );
};

export default Footer;
